// extracted by mini-css-extract-plugin
export default {"wrapper":"Gr-z","response":"Hr-z","error":"Ir-z","disabled":"Jr-z","buttons":"Kr-z","feedbackQuestionSection":"Lr-z","yesNoWrapper":"Mr-z"};